class AnnouncementBar extends HTMLElement {
  constructor() {
    super()
    this.closeButton = this.querySelector('.js-announcement-bar-close')
  }

  connectedCallback() {
    this.closeButton?.addEventListener('click', this.onClick.bind(this))
    this.checkSessionStorage()
  }

  disconnectedCallback() {
    this.closeButton?.removeEventListener('click', this.onClick)
  }

  onClick() {
    this.setAttribute('hidden', '')
    sessionStorage.setItem('announcement-bar:closed', true)
  }

  checkSessionStorage() {
    const isClosed = sessionStorage.getItem('announcement-bar:closed')
    this.toggleAttribute('hidden', isClosed !== null)
  }
}

if (!customElements.get('hh-announcement-bar')) {
  customElements.define('hh-announcement-bar', AnnouncementBar);
}